import { createAsyncThunk } from '@reduxjs/toolkit'
import okHttp from '@helper/okHttp'
import { sys, getTypePrefix } from '@/api'

/**
 * 用户登录
 * @returns {Promise<void>}
 */
export const loginAction = createAsyncThunk(
    getTypePrefix(sys.login),
    async (data) => await okHttp(sys.login, {
        method: 'POST',
        data
    })
)

export const futailLoginAction = createAsyncThunk(
    getTypePrefix(sys.futailLogin),
    async (params) => await okHttp(sys.futailLogin, {
        method: 'POST',
	    params
    })
)

/**
 * 钉钉扫码登录
 * @returns {Promise<void}}
 */
export const dingtalkLoginAction = createAsyncThunk(
    getTypePrefix(sys.dingtalkLogin),
    async (data) => await okHttp(sys.dingtalkLogin, {
        method: 'POST',
        data
    })
)

/**
 * 获取用户信息
 * @returns {Promise<void>}
 */
export const getUserInfoAction = createAsyncThunk(
    getTypePrefix(sys.getUserInfo),
    async () => await okHttp(sys.getUserInfo, {
        method: 'GET'
    })
)

/**
 * 登出
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const logoutAction = createAsyncThunk(
    getTypePrefix(sys.logout),
    async () => await okHttp(sys.logout, {
        method: 'POST'
    })
)

/**
 * 修改密码
 * @type {AsyncThunk<Promise<*>, void, AsyncThunkConfig>}
 */
export const changePasswordAction = createAsyncThunk(
    getTypePrefix(sys.changePasswordUrl),
    async (data) => await okHttp(sys.changePasswordUrl, {
        method: 'POST',
	    data
    })
)
